<template>
  <q-page class="row justify-center items-center">
    <div class="text-center">
      <q-icon name="error_outline" style="font-size: 6em;" class="text-red-3 q-mb-sm" /><br>
      <div class="text-red-5 text-bold q-mb-md">
        Widget was updated.<br> Please restart to proceed.
      </div>
    </div>
    <portal to="footer">
      <BaseFooterFrame>
        <q-btn
          color="primary"
          size="16px"
          unelevated
          no-caps
          class="full-width q-btn--generic"
          @click="restartHandler"
          label="Restart" />
      </BaseFooterFrame>
    </portal>
  </q-page>
</template>

<script>
export default {
  name: 'ChunkNotFound',
  methods: {
    restartHandler () {
      if (this.$q.platform.within.iframe) {
        window.xprops.onRestart()
      } else {
        location.replace('/')
      }
    }
  }
}
</script>
